
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AclInterface } from 'projects/f-cms/src/app/models/aclInterface';

@Injectable({
  providedIn: 'root'
})
export class PermissionMenuService {

    updateList$ = new Subject<AclInterface>();

    constructor(){

    }

    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
    }

    updateList(acl: AclInterface){
        this.updateList$.next(acl);
    }

    subcribeToUpdate(){
        return this.updateList$.asObservable();
    }
}
